edit.classy.controller({
    name: 'EditExpensesController',
    inject: ['$scope', 'ApplicationSideBarService', 'AskSchoolSpecificQuestionsModelService', 'FamilyModelService', 'ApplicationService', 'SchoolModelService', 'DateService',
        'CalculationService', 'AlertService', '$sce', '$modal', '$http', 'MedianExpenseModelService', 'authServiceFactory', '$timeout', 'SliderService'],
    init: function()
    {
        this.$.ApplicationSideBarService = this.ApplicationSideBarService;
        this.$.ApplicationService = this.ApplicationService;
        this.$.CalculationService = this.CalculationService;
        this.$.AlertService = this.AlertService;
        this.$.versionNo = versionNo;
        this.$.$sce = this.$sce;
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        this.$.newLetter = 0;
        this.$.familyLetter = '';
        this.$.questions = this.AskSchoolSpecificQuestionsModelService.get();
        this.$.SliderService = this.SliderService;
        this.$timeout(function() {
            var $window = $(window).on('resize', function(){
                var height = $(this).height() - 206;
                var slideoutTabWidth = $(".slideout-tabs").width();
                $(".slideout-tabs .nav-tabs").css("width", slideoutTabWidth + 'px');
            }).trigger('resize');
            var slideoutTabHeight = $(".slideout-tabs .nav-tabs").height();
            $(".data-start").css("margin-top", slideoutTabHeight + 'px');
        }, 300);
        
        this.$.origMort = 0;
        for (var i = 0; i < this.ApplicationService.getFamilyData().real_estate.length; i++) {
            this.$.origMort += parseInt(this.ApplicationService.getFamilyData().real_estate[i].Rea_Mort_Pay)
        }

        this.$.isArchive = this.ApplicationService.getAwardData().isArchive;
        this.$.DateService = this.DateService;
    },
    startSaveProcess: function(scope, instance, form) {
        instance.options.factor  = .3;
        var self = this;

        var putData = {};
        var data =  this.ApplicationService.getFamilyData().edit_sums;
        putData.Rea_Mort_Pay = data.Rea_Mort_Pay;
        putData.Exp_Rent = data.Exp_Rent;
        putData.Exp_HomeIns = data.Exp_HomeIns;
        putData.Exp_Life_Ins = data.Exp_Life_Ins;
        putData.Exp_Health_Ins = data.Exp_Health_Ins;
        putData.Exp_Auto_Ins = data.Exp_Auto_Ins;
        putData.Exp_Elec = data.Exp_Elec;
        putData.Exp_Heat = data.Exp_Heat;
        putData.Exp_Util = data.Exp_Util;
        putData.Exp_Med_Val = data.Exp_Med_Val;
        putData.Exp_Loan_Val = data.Exp_Loan_Val;
        putData.Exp_Dep_Val = data.Exp_Dep_Val;
        putData.Exp_Charity = data.Exp_Charity;
        putData.Exp_Childcare_Val = data.Exp_Childcare_Val;
        putData.Exp_Other_Val = data.Exp_Other_Val;
        angular.forEach(putData, function(value, key) {
            if (putData[key]=='')
                putData[key]=0;
        })

        //this.ApplicationService.getFamilyData().awardData.reportedIncome = parseInt(putData.Inc_Annual_1) + parseInt(putData.Inc_Annual_2) + parseInt(putData.Inc_Business) + parseInt(putData.Inc_Div_Int) + parseInt(putData.Inc_Cap_Gain) + parseInt(putData.Inc_Estate) + parseInt(putData.Inc_Trust) + parseInt(putData.Inc_Child_Supp) + parseInt(putData.Inc_Alimony) + parseInt(putData.Inc_Gifts) + parseInt(putData.Inc_Other) - parseInt(putData.Exp_Child_Supp) - parseInt(putData.Exp_Alimony);

        return this.$http.put("/api/family/" + data.familyID + '/editsums/' + data.applicationID, data).success(function(data, status, headers, config) {
            self.CalculationService.reCalc();
            instance.options.callMe(data, status, headers, config, instance);
        });
    }

});


/* End accountInfo Module */
